import type { ProductItemThemeSettings } from '@providers/ThemeProvider/types';

import type { ProductLabelProps } from '@/features/filter-product-list/product-list/product-item/ProductLabel';

export type ProductLabelPropsMapSettings = Omit<
  ProductLabelProps,
  'onRender' | 'imgAttrs' | 'imgAlt' | 'labelType'
>;

export const useConnectProductLabel = (
  settings: ProductItemThemeSettings,
  type: 'productSaleLabel' | 'productSoldOutLabel' | 'productCustomLabelByTag'
) => {
  const productLabelSettings = settings.productImg.elements?.[type];

  return {
    props: productLabelSettings,
  };
};
